import { IRewardsContext, IRewardsEmailTemplate, IRewardsHistoryDetails } from '../interfaces/rewards';
import { RewardsOrderStatus } from '../types/rewards';

export const REWARDS_INFO_MOCK_RESPONSE = {
  data: {
    rewardsInfo: {
      accountId: 'tiSn8OGPSJriNabNXguB',
      countryCode: 'CL',
      createdAt: '2023-11-23T03:00:00.851Z',
      id: '2346',
      hasCreditLine: true,
      updatedAt: '2023-11-23T03:00:00.710Z',
      account: {
        balance: 1220000,
        currency: 'CLP',
        maxBalance: 'None',
        status: 'active',
        createdAt: '2023-11-02T17:27:16.320Z',
        updatedAt: '2023-11-30T20:45:58.260Z'
      },
      selectedCollaborators: [
        {
          fullName: 'Lara, Jorge',
          documentValue: '1-9',
          joinedAt: undefined,
          id: '1',
          hasSendEmail: true,
          status: 'in_progress',
          email: 'jlara@mail.com',
          birthDate: '01/01/1990',
          plans: ['2']
        },
        {
          fullName: 'Navarrete, Rodrigo',
          documentValue: '2-7',
          joinedAt: '01/02/1995',
          id: '2',
          hasSendEmail: false,
          status: 'active',
          email: 'rnavarrete@mail.com',
          birthDate: '01/01/1990',
          plans: ['2']
        }
      ],
      internalProducts: [
        {
          countryCode: 'CL',
          createdAt: '2023-11-21T03:00:00.600Z',
          id: 'balance-cl',
          name: 'Saldo Chile',
          type: 'balance',
          provider: 'betterfly',
          price: 1,
          updatedAt: '2023-11-14T03:00:00.439Z'
        },
        {
          countryCode: 'CL',
          createdAt: '2023-11-15T03:00:00.884Z',
          currency: 'CLP',
          id: 'points-cl',
          name: 'Puntos Chile',
          type: 'points',
          provider: 'betterfly',
          price: 1,
          updatedAt: '2023-11-15T03:00:00.072Z'
        }
      ]
    },
    paymentInfo: {
      name: 'CONECTEN SPA',
      id: '76.334.224-7',
      accountType: 'Cta corriente - Banco BBVA',
      accountNumber: '0011-0372-01-00055973'
    }
  }
};

export const MOCK_REWARDS_DEPOSIT_RESPONSE = {
  data: {
    orderLabel: '0023'
  }
};

export const REWARDS_PROVIDER_MOCK: IRewardsContext = {
  balance: 122000,
  hasCreditLine: true,
  transferData: {
    name: 'CONECTEN SPA',
    id: '76.334.224-7',
    idType: 'RUT',
    accountType: 'Cta corriente - Banco BBVA',
    accountNumber: '0011-0372-01-00055973',
    email: 'email@email.com',
    clabe: '1234567890'
  },
  currency: 'CLP',
  externalId: '2346',
  countryCode: 'CL',
  loading: false,
  error: false,
  internalProducts: [
    {
      countryCode: 'CL',
      createdAt: '2023-11-21T03:00:00.600Z',
      id: 'balance-cl',
      name: 'Saldo Chile',
      type: 'balance',
      provider: 'betterfly',
      price: 1,
      updatedAt: '2023-11-14T03:00:00.439Z'
    },
    {
      countryCode: 'CL',
      createdAt: '2023-11-15T03:00:00.884Z',
      currency: 'CLP',
      id: 'points-cl',
      name: 'Puntos Chile',
      type: 'points',
      provider: 'betterfly',
      price: 1,
      updatedAt: '2023-11-15T03:00:00.072Z'
    }
  ],
  selectedCollaborators: [
    {
      fullName: 'Lara, Jorge',
      documentValue: '1-9',
      nationalIdentifications: {
        type: 'rut',
        idValue: '1-9'
      },
      joinedAt: undefined,
      id: '1',
      hasSendEmail: true,
      status: 'in_progress',
      email: 'jlara@mail.com',
      birthDate: '01/01/1990',
      plans: ['2']
    },
    {
      fullName: 'Navarrete, Rodrigo',
      documentValue: '2-7',
      nationalIdentifications: {
        type: 'rut',
        idValue: '2-7'
      },
      joinedAt: '01/02/1995',
      id: '2',
      hasSendEmail: false,
      status: 'active',
      email: 'rnavarrete@mail.com',
      birthDate: '01/01/1990',
      plans: ['2']
    }
  ],
  changeSelectedCollaborators: () => {
    return;
  },
  tableState: undefined,
  setTableState: () => {
    return;
  },
  updateBalance: () => {
    return;
  }
};

export const REWARDS_ORDER_DETAIL_MOCK_RESPONSE: IRewardsHistoryDetails = {
  orderInfo: {
    id: '94270eb8-099e-4cf1-96a0-bf8255c4ffc3',
    status: 'invoice-pending',
    transactionDetail: 'points',
    amount: 3000,
    email: 'test@betterfly.com',
    createdAt: '22/01/2024',
    orderNumber: 'CL-1705948801378',
    orderLoads: '3',
    currency: 'CLP',
    paymentMethod: 'balance',
    transactionType: 'outgoings'
  },
  orderDetails: [
    {
      email: 'test1@betterfly.com',
      name: '',
      status: 'pending',
      amount: 1000,
      currency: 'CLP'
    },
    {
      email: 'test2@betterfly.com',
      name: '',
      status: 'pending',
      amount: 1000,
      currency: 'CLP'
    },
    {
      email: 'test3@betterfly.com',
      name: 'rodrigo naranjo marchant',
      status: 'pending',
      amount: 1000,
      currency: 'CLP'
    }
  ]
};

export const REWARDS_ORDER_MOCK_RESPONSE = {
  data: {
    companyId: '2346',
    orders: [
      {
        id: '1',
        email: 'dfsd@sdfdsf.com',
        transactionDetail: '1',
        createdAt: '2023-11-23T03:00:00.851Z',
        amount: '100',
        orderNumber: '1',
        status: 'done' as RewardsOrderStatus
      },
      {
        id: '2',
        email: 'dfsd@sdfdsf.com',
        transactionDetail: '2',
        createdAt: undefined,
        amount: '200',
        orderNumber: '2',
        status: 'invoice-pending' as RewardsOrderStatus
      },
      {
        id: '3',
        email: 'dfsd@sdfdsf.com',
        transactionDetail: '3',
        createdAt: '2023-12-23T03:00:00.851Z',
        amount: '300',
        orderNumber: '3',
        status: 'pending-payment' as RewardsOrderStatus
      },
      {
        id: '4',
        email: 'dfsd@sdfdsf.com',
        transactionDetail: '4',
        createdAt: '2023-12-23T03:00:00.851Z',
        amount: '400',
        orderNumber: '4',
        status: 'pending-delivery' as RewardsOrderStatus
      },
      {
        id: '5',
        email: 'dfsd@sdfdsf.com',
        transactionDetail: '5',
        createdAt: '2023-12-23T03:00:00.851Z',
        amount: '500',
        orderNumber: '5',
        status: 'voided' as RewardsOrderStatus
      }
    ]
  }
};

export const MOCK_COLLABORATORS = [
  {
    fullName: 'Lara, Jorge',
    documentValue: '1-9',
    joinedAt: undefined,
    id: '1',
    hasSendEmail: true,
    status: 'in_progress',
    email: 'jlara@mail.com',
    birthDate: '01/01/1990',
    plans: ['2']
  }
];

export const MOCK_POINTS_FILE_VALIDATION_RESPONSE = {
  valid: false,
  totalAmount: 100,
  validsCount: 7,
  errorsCount: 10,
  hasBalance: true,
  orders: [
    {
      points: '20',
      members: [
        {
          email: 'test4@betterfly.com',
          name: ''
        },
        {
          email: 'test5@betterfly.com',
          name: ''
        }
      ]
    },
    {
      points: '15',
      members: [
        {
          email: 'cj@test.jc',
          name: 'carlos iglesias monsalve'
        },
        {
          email: 'cj@test.jc',
          name: ''
        }
      ]
    },
    {
      points: '10',
      members: [
        {
          email: 'test6@betterfly.com',
          name: ''
        },
        {
          email: 'test7@betterfly.com',
          name: ''
        },
        {
          email: 'test8@betterfly.com',
          name: ''
        }
      ]
    }
  ],
  errors: 'error file'
};

export const MOCK_POINTS_FILE_VALIDATION_ONE_MEMBER = {
  valid: true,
  totalAmount: 1,
  validsCount: 1,
  errorsCount: 0,
  hasBalance: true,
  orders: [
    {
      points: '1',
      members: [
        {
          email: 'test9@betterfly.com',
          name: ''
        }
      ]
    }
  ],
  errors: ''
};

export const MOCK_REWARDS_ORDER_ERROR_FILE_RESPONSE = {
  data: {
    file: 'excel'
  }
};

export const MOCK_EMAIL_TEMPLATE: IRewardsEmailTemplate = {
  template: '<div>Template</div>'
};
